import { HttpClient } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import { environment } from '@env/environment';
import type { RealtimeTicketResponse } from '@shared/api/identity/dtos/responses/realtime-ticket.response';
import { withAuthInBackground } from '@shared/utils/http-context.util';
import type { Observable } from 'rxjs';

@Service()
export class RealtimeTicketClient {
  private readonly http = inject(HttpClient);

  issueTicket(): Observable<RealtimeTicketResponse> {
    return this.http.post<RealtimeTicketResponse>(`${environment.urlApiPlatform}realtime/ticket`, null, withAuthInBackground());
  }
}
